import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'
import { type FieldErrors, type FieldValues } from 'react-hook-form'

import { ACTIONS } from '@/constants/common/message.constants'

import { Button } from '../Button'

type Props<T extends FieldValues = FieldValues> = ComponentPropsWithoutRef<
  typeof Button
> & {
  errors?: FieldErrors<T>
}

export const SearchFormSubmitButton: FC<Props> = ({
  className,
  children = ACTIONS.SEARCH,
  errors,
  ...props
}) => {
  const hasErrors = Object.keys(errors ?? {}).length > 0
  return (
    <Button
      type="primary"
      {...props}
      htmlType="submit"
      className={clsx(['rounded-[5px]', className])}
      disabled={hasErrors}
    >
      <span className="min-w-[88px]">{children}</span>
    </Button>
  )
}
